<template>
  <div class="gc-footer">
    <span v-if="standardSetLabel" :class="{locked: blurLock}">{{ standardSetLabel }}</span>
    <span v-if="standardRef" :class="{locked: blurLock}">{{ standardRef }}</span>
    <div
      v-if="showProgress || hasNonEnglishLanguages()"
      class="icons"
      tabindex="0"
      v-tooltip.bottom="hasNonEnglishLanguages() ? progressTooltip + progressAndLanguageTooltip : progressTooltip"
      :aria-label="iconLabel()"
    >
      <span
        v-if="hasNonEnglishLanguages()"
        class="globe-icon"
      ><i class="fa fa-globe" /></span>
      <span
        v-if="showProgress"
        class="progress-icon"
        v-html="pmaSvg"/>
    </div>
  </div>
</template>

<script>
import { tooltip } from 'uiv'
import { pmaSvg } from '@/icons'

export default {
  name: 'GoalCardFooter',
  directives: { tooltip },
  props: {
    standardSetLabel: {
      type: String,
      default: ''
    },
    standardRef: {
      type: String,
      default: ''
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    resourceLanguages: {
      type: Array,
      default: () => []
    },
    blurLock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pmaSvg: pmaSvg
    }
  },
  methods: {
    formatLanguages() {
      return this.resourceLanguages.reduce((filtered, lang) => {
        if (lang !== 'english') {
          filtered.push(this.capitalize(lang));
        }
        return filtered;
      }, []).join(', ')
    },
    capitalize(lowerString) {
      const lower = lowerString.toLowerCase();
      return lowerString.charAt(0).toUpperCase() + lower.slice(1);
    },
    iconLabel() {
      let label = '';
      if (this.hasNonEnglishLanguages()) {
        label += 'Has assessments in multiple languages, including ' + this.formatLanguages() + '.';
      }
      if (this.showProgress) {
        label += 'Has progress monitoring assessments and data sheets.';
      }
      return label;
    },
    hasNonEnglishLanguages() {
      return this.resourceLanguages?.some((lang) => lang != 'english')
    }
  },
  computed: {
    progressTooltip() {
      return `<div class='tooltip-inner-container'>${this.pmaSvg} <p>Progress monitoring assessments and data sheets</p></div>`
    },
    progressAndLanguageTooltip() {
      return  `<div class='tooltip-inner-container'><i class='fa fa-globe' aria-hidden='true'></i> <p>Includes assessments in <b>${this.formatLanguages()}</b></p></div>`
    }
  }
}
</script>

<style lang="less" scoped>
@import './colors.less';

.gc-footer {
  color: @textPrimary;
  font-size: 12px;
  line-height: 16px;
  height: 16px;

  display: flex;
  align-items: center;

  .progress-icon {
    padding-top: 2px;
    margin-left: auto;
  }

  span {
    margin-right: 0.45em;
  }
  .icons {
    margin-left: auto;
    color: black;

    span {
      display: inline-block;
      vertical-align: text-top;
      margin: auto;
    }
    .globe-icon i {
      font-size: 16px;
    }
  }
}
</style>
<style lang="less">
.tooltip-inner {
  text-align: left;
  color: white;
  max-width: 230px;
  p {
    padding: 6px 6px 0px 6px;
  }
  i {
    margin-left: 2px;
    margin-right: 2px;
    font-size: 18px;
    margin-top: 5px;
  }
  svg {
    width: 19px;
    height: 18px;
    margin-left: 3px;
    margin-right: 3px;
    margin-top: 5px;
  }
  svg {
    width: 19px;
    height: 18px;
    margin: 5px 3px 0px 3px;
  }
  .tooltip-inner-container {
    display: flex;
  }
}
</style>
